<template>
  <div class="roomType">
    <img src="" alt="" srcset="">
    <div class="roomContainer">
      <div class="headTab">
        <div :class="['tab-item', {'active': index == activeStyleIndex }]" v-for="(style, index) in styleList" :key="'style'+ index" @click="selectStyle(style, index)">{{style.style_name}}</div>
      </div>
      <div class="roomBox">
        <div class="activity-swiper">
          <el-carousel
            trigger="click"
            :interval="6000"
            :arrow="swpierList.length > 1 ? 'hover' : 'never'"
          >
            <el-carousel-item v-for="(item, index) in swpierList" :key="index">
              <div class="swiper-box">
                <img class="image" :src="item.pic_url" alt="" srcset="" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="right-box" v-if="roomList">
          <div :class="['room', {active: index == activeRoomIndex}]" v-for="(room, index) in roomList" :key="'room'+ index" @click="selectedRoom(room, index)">
            {{room.room_name}}
          </div>
          <div class="backHouse" @click="goHouse">
            <img class="refresh" src="@/assets/renew/refresh.png" alt="">
            切换户型
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const md5 = require('js-md5')
export default {
  name: 'roomType',
  components:{ 
    
  },
  props: {
    house_id: ''
  },
  data() {
    return {
      search: {
        house_id: '',
        style_id: ''
      },
      styleList: [],
      swpierList: [],
      roomList: [],
      activeStyleIndex: 0,
      oldStyleIndex: 0,
      activeRoomIndex: 0
    }
  },
  computed:{ },
  watch:{ },
  created() {
      this.search.house_id = this.house_id
      this.getStyleList()
  },
  mounted() {
      
  },
  methods: {
     // 切换户型，返回上一页
    goSelectHouse() {
      this.$router.go(-1)
    },
    getStyleList() {
      this.showloading = true
      const stamp = Date.now()
      const key = atob(localStorage.getItem('okey'))
      const token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
      const { house_id } = this.search
      axios.get('/interface/searchRenewHouseStyle', {
        params: {
          house_id,
          pageNum: -1,
          pageSize: 20,
          is_hidden: '',
          token,
          stamp,
          sign: md5(`${stamp}-120${key}`)
        }
      }).then((res) => {
        console.log(111, res)
        this.showloading = false
        if (res.data.result === 1) {
          this.styleList = res.data.data
          if (this.styleList.length) {
            this.search.style_id = this.styleList[this.activeStyleIndex].id
            this.getRoomInfo()
          } else {
            this.$toast('暂无可预览风格 请切换户型')
          }
        }
      })
    },
    // 获取房间信息
    getRoomInfo() {
      this.showloading = true
      const stamp = Date.now()
      const key = atob(localStorage.getItem('okey'))
      const token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
      const { house_id, style_id } = this.search
      axios.get('/interface/searchRenewHouseRoom', {
        params: {
          house_id,
          style_id,
          pageNum: -1,
          pageSize: 20,
          is_hidden: '',
          token,
          stamp,
          sign: md5(`${stamp}${-1}${20}${key}`)
        }
      }).then((res) => {
        this.showloading = false
        if (res.data.result === 1) {
          if (res.data.data.length) {
            this.roomList = res.data.data.map(item => {
              item.room_photos_pc = item.room_photos_pc ? JSON.parse(item.room_photos_pc) : []
              if (this.styleList[this.activeStyleIndex].products) {
                const styleProducts = JSON.parse(this.styleList[this.activeStyleIndex].products)
                const roomProducts = item.products ? JSON.parse(item.products) : []
                item.products = [...new Set([...roomProducts, ...styleProducts])]
              }
              return item
            })
            console.log(3213123,this.activeStyleIndex, this.roomList, this.roomList[this.activeRoomIndex])
            this.swpierList = this.roomList[this.activeRoomIndex].room_photos_pc
            this.oldStyleIndex = this.activeStyleIndex
          } else {
            this.activeStyleIndex = this.oldStyleIndex
            this.$message.info('此风格暂无可预览房间')
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    selectStyle(value, index) {
      this.activeStyleIndex = index
      this.search.style_id = value.id
      this.activeRoomIndex = 0
      this.getRoomInfo()
    },
    selectedRoom(val, index) {
      this.activeRoomIndex = index
      console.log('selectedRoom', val)
      this.swpierList = val.room_photos_pc ? val.room_photos_pc : []
    },
    goHouse() {
      this.$emit('gohouse')
    }
  }
}
</script>
<style lang='less' scoped>
.roomType {
  width: 1920px;
  height: 972px;
  position: relative;
  .roomContainer {
    width: 1408px;
    height: 765px;
    background: #FFFFFF;
    border-radius: 15px;
    position: absolute;
    top: 113px;
    left: 50%;
    transform: translateX(-50%);
    .headTab {
      padding: 0 20px;
      width: 100%;
      height: 61px;
      position: absolute;
      top:  -61px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      .tab-item {
        width: 229px;
        height: 47px;
        line-height: 47px;
        cursor: pointer;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        font-weight: 400;
        font-size: 24px;
        color: #EAEAEA;
        background: #A5A5A5;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: -1;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          box-shadow: 0px 0px 3px 2px rgba(255,255,255, 0.75);
        }
        &.active {
          height: 61px;
          line-height: 61px;
          background: #4E8B46;
          font-weight: 400;
          font-size: 32px;
          color: #FFFFFF;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          &::before {
            z-index: 1;
          }
        }
      }
    }
    .roomBox {
      display: flex;
      padding: 20px;
      .right-box {
        padding: 72px 72px 136px 51px;
        display: flex;
        flex-direction: column;
        position: relative;
        .room {
          width: 170px;
          height: 46px;
          border-radius: 23px;
          border: 2px solid #4E8B46;
          font-weight: 400;
          font-size: 24px;
          color: #4E8B46;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          &.active {
            background: #4E8B46;
            color: #fff;
          }
        }
        .backHouse {
          width: 170px;
          height: 46px;
          border-radius: 23px;
          border: 2px solid #4E8B46;
          position: absolute;
          left: 51px;
          bottom: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 400;
          font-size: 22px;
          color: #4E8B46;
          cursor: pointer;
          .refresh {
            width: 24px;
            height: 24px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  .activity-swiper {
    width: 1095px;
    height: 725px;
    border-radius: 15px;
    overflow: hidden;
    .swiper-box {
      width: 100%;
      max-width: 1920px;
      height: 725px;
      position: relative;
      .oneSwiper {
        position: absolute;
        left:0;
        top: 0;
        .signup-btn {
          width: 262px;
          height: 80px;
          position: absolute;
          bottom: 110.5px;
          left: 50%;
          transform: translateX(-50%);
          cursor: pointer;
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .scale {
        animation: imageScale 1s forwards;
      }
      .content {
        width: 100%;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title {
          font-size: 48px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 25px;
          margin-bottom: 32px;
        }
        .descr {
          font-size: 28px;
          color: #FFFFFF;
          line-height: 36px;
          margin: 0 auto;
          p {
            margin: 0;
          }
        }
      }
      // .content.textAnimated {
      //   // animation: textFadeupin  1.6s forwards;
      // }
    }
    /deep/ .el-carousel__container {
      height: 725px;
      max-height: 725px;
    }
    /deep/ .el-carousel__indicators {
      bottom: 37px;
    }
    /deep/ .el-carousel__button {
      width: 68px;
      height: 8px;
      background: #fff;
      display: none;
    }
    // /deep/ .el-carousel__indicator.is-active {
    //   .el-carousel__button{
    //     background: #009538
    //   }
    // }
  }
}
</style>
<style>
@keyframes imageScale {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}
</style>